import axios from "axios";

export const addNewUser = async (data: any) => {
    return await axios.post("/api/user", data);
}